import { apiInstance } from "./ApiInstance";
import { pageLimit } from "../Utils/helper";

export const getInvestigatorListWithCaseId = async (payload) => {
  const { data = {} } = await apiInstance.post(
    "/api/case/investigator-list",
    payload
  );
  return data;
};

export const getAllApprovalCasesList = async (route, payload) => {
  // let apiEndPoint = `api/case/approval/${route}-list?offset=${offset}&limit=${pageLimit}`;
  // if (route === "Garage" || route === "Hospital") {
  //   apiEndPoint = `de-empanel/${route}-approval-list?offset=${offset}&limit=${pageLimit}`;
  // }
  // if (route === "Police") {
  //   apiEndPoint = `de-empanel/${route}-approval-list?offset=${offset}&limit=${pageLimit}`;
  // }
  // let { data = {} } = await apiInstance.get(apiEndPoint);
  // return data;
  let apiEndPoint = `api/case/approval/${route}-list`;
  if (route === "Garage" || route === "Hospital" || route === "Police") {
    apiEndPoint = `de-empanel/${route}-approval-list`;
  }
  let { data = {} } = await apiInstance.post(apiEndPoint, payload);
  return data;
};
export const approvalAllSearchApi = async (route, payload) => {
  let apiEndPoint = `api/case/approval/${route}-list`;
  if (route === "Garage" || route === "Hospital" || route === "Police") {
    apiEndPoint = `de-empanel/${route}-approval-list`;
  }
  let { data = {} } = await apiInstance.post(apiEndPoint, payload);
  return data;
};

export const getDeEmpanelSegmentInfo = async (caseId, type, blacklistType) => {
  if (type === "Hospital" || type === "hospital") {
    let { data = {} } = await apiInstance.get(
      `de-empanel/${type}-segment-list?case_id=${caseId}&blacklistType=${blacklistType}`
    );
    return data;
  } else {
    let { data = {} } = await apiInstance.get(
      `de-empanel/${type}-segment-list?case_id=${caseId}`
    );
    return data;
  }
};

export const getAllApprovalCasesSegmentInfo = async (
  route,
  payload,
  type,
  signal
) => {
  if (route === "Recommendation") {
    return getDeEmpanelSegmentInfo(
      payload?.caseId,
      type,
      payload?.blacklistType
    );
  }
  let { data = {} } = await apiInstance.post(
    `/api/case/get-case-details/${route}`,
    payload,
    { signal }
  );
  return data;
};

export const recommendationActionApi = async (route, payload) => {
  let { data = {} } = await apiInstance.put(
    `de-empanel/blacklisted-decision-${route}`,
    payload
  );
  return data;
};

export const approvalFlagPutApi = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/case/star/${caseId}`,
    payload
  );
  return data;
};

export const getInvestigatorDetails = async (payload) => {
  let { data = {} } = await apiInstance?.post(
    "/api/case/investigator-details",
    payload
  );
  return data;
};

export const getVendorBlock = async (payload) => {
  let { data = {} } = await apiInstance?.post(
    "/api/case/investigator-list",
    payload
  );
  return data;
};

export const getInvoiceVendorBlock = async (payload) => {
  let { data = {} } = await apiInstance?.post(
    "/api/invoice/list/details",
    payload
  );
  return data;
};

export const getRejectedInvestigationDetails = async (caseId, route) => {
  let { data = {} } = await apiInstance?.get(
    `/api/bimasathi/rejected-investigation-details/${caseId}?limit=${route?.limit}&offset=${route?.offset}`
  );
  return data;
};

// export const getVendorList = async (state, city, caseId) => {
//   let { data = {} } = await apiInstance?.get(
//     `/api/allocation/vendor-list?city=${city}&state=${state}&case_id=${caseId}`
//   );
//   return data;
// };

export const getVendorList = async (state, city, caseId) => {
  const { data = {} } = await apiInstance.get('/api/allocation/vendor-list', {
    params: {
      city,
      state,
      case_id: caseId,
    },
  });
  return data;
};

export const getIndividualBlockDetails = async (caseId, payload) => {
  let { data = {} } = await apiInstance?.post(
    `/api/case/get-investigator-individual-block-details/${caseId}`,
    payload
  );
  return data;
};

export const getInvoicesByCaseId = async (caseId, payload) => {
  let { data = {} } = await apiInstance?.post(
    `/api/invoice/${caseId}`,
    payload
  );
  return data;
};

export const approveInvoicesByCaseId = async (caseId, payload) => {
  let { data = {} } = await apiInstance?.put(
    `/api/invoice/approve/${caseId}`,
    payload
  );
  return data;
};

export const rejectInvoicesByCaseId = async (caseId, payload) => {
  let { data = {} } = await apiInstance?.put(
    `/api/invoice/reject/${caseId}`,
    payload
  );
  return data;
};
export const bsInvestigationAction = async (payload) => {
  let { data = {} } = await apiInstance?.post(
    `/api/bimasathi/investigation/action`,
    payload
  );
  return data;
};
export const getVendorAssessmentData = async (caseId) => {
  let { data = {} } = await apiInstance.get(`/vendor/vendor-list/${caseId}`);
  return data;
};

export const putVendorAssessmentData = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/vendor/vendor-assess/${caseId}`,
    payload
  );
  return data;
};

export const getInvestigationReport = async (caseId, payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/investigation/investigation-report/${caseId}`,
    payload
  );
  return data;
};

export const putInvestigationReportsApproval = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/investigation/investigation-report/approve/${caseId}`,
    payload
  );
  return data;
};
export const putInvestigationReportsReject = async (caseId, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/investigation/investigation-report/reject/${caseId}`,
    payload
  );
  return data;
};

export const getBlocksAsPerLobName = async (lobName, payload) => {
  let { data = {} } = await apiInstance.get(
    `/api/case/blocks-by-lob/${lobName}`,
    payload
  );
  return data;
};

export const putReassignVendor = async (type, payload) => {
  let { data = {} } = await apiInstance.put(
    `/api/allocation/auto/vendor-allocate/${type}-vendor`,
    payload
  );
  return data;
};

export const reassignToBSFromBSTL = async (payload, type) => {
  let { data = {} } = await apiInstance.put(
    "/api/bimasathi/assign-bs",
    payload,
    type
  );
  return data;
};

export const putReassignVendorManual = async (payload) => {
  let { data = {} } = await apiInstance.post(
    "/api/allocation/manual/vendor-allocate",
    payload
  );
  return data;
};

export const approvedAll = async (caseId, payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/invoice/approveAll/${caseId}`,
    payload
  );
  return data;
};
export const rejectAll = async (caseId, payload) => {
  let { data = {} } = await apiInstance.post(
    `/api/invoice/rejectAll/${caseId}`,
    payload
  );
  return data;
};

export const deEmpanelBlacklist = async (payload, route) => {
  let { data = {} } = await apiInstance.put(
    `/de-empanel/blacklisted-all-decision-${route}`,
    payload
  );
  return data;
};

export const caseClosedStatus = async (caseId) => {
  let { data = {} } = await apiInstance.get(`/api/case/case-closed/${caseId}`);
  return data;
};

export const bimasathiInvestigationDetails = async (caseId, route) => {
  let { data = {} } = await apiInstance.get(
    `/api/bimasathi/investigation-details/${caseId}?limit=${route?.limit}&offset=${route?.offset}`
  );
  return data;
};

export const getJPInvoiceDetails = async (payload) => {
  let { data = {} } = await apiInstance.get(
    `/api/invoice/approve-invoice-jp?token=${payload}`,
    payload
  );
  return data;
};
